import {FaRegCommentDots, FaRegHandRock} from "react-icons/fa";
import {CgNotes} from "react-icons/cg";

export default [
    {
        title: "Comments",
        key: "comments",
        icon: FaRegCommentDots,
    }, {
        title: "Notebook",
        key: "notebook",
        icon: CgNotes ,
    },
    {
        title: "My Practice",
        key: "practice",
        icon: FaRegHandRock ,
    }
]